import { render, staticRenderFns } from "./AccordionItemForeign.vue?vue&type=template&id=062260ed&scoped=true"
import script from "./AccordionItemForeign.vue?vue&type=script&lang=js"
export * from "./AccordionItemForeign.vue?vue&type=script&lang=js"
import style0 from "./AccordionItemForeign.vue?vue&type=style&index=0&id=062260ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062260ed",
  null
  
)

export default component.exports